var map = {
	"./basket-empty-icon.svg": [
		"64d1"
	],
	"./basket-filled-icon.svg": [
		"cc10"
	],
	"./check-circle.svg": [
		"f9be",
		"chunk-2d22e10c"
	],
	"./evening.svg": [
		"1dcd",
		"chunk-2d0b6aea"
	],
	"./globe.svg": [
		"9639",
		"chunk-2d0e5b39"
	],
	"./icon-arrow.svg": [
		"a47d",
		"chunk-2d208336"
	],
	"./icon-cross-graphite.svg": [
		"a00b",
		"chunk-2d207357"
	],
	"./icon-cross-grey.svg": [
		"288c",
		"chunk-2d0b34e7"
	],
	"./icon-minus.svg": [
		"1fa8",
		"chunk-2d0b7202"
	],
	"./icon-plus.svg": [
		"6bc6",
		"chunk-2d0da915"
	],
	"./icon-shopping-bag.svg": [
		"7add",
		"chunk-2d0e1a00"
	],
	"./morning.svg": [
		"d29c",
		"chunk-2d21d90e"
	],
	"./morningAndEvening.svg": [
		"faa7",
		"chunk-2d2376e7"
	],
	"./paypal.svg": [
		"60eb",
		"chunk-2d0cedcd"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ab81";
module.exports = webpackAsyncContext;